function validateFields(target, action) {
    var that = $(target);
    $('.js-form-group').removeClass('has-error');
    that.find('button[type="submit"]').prop('disabled', 'disabled');
    var data = new FormData(that[0]);
    data.append('action', action);

    $.ajax({
        url: ajaxurl,
        data: data,
        processData: false,
        contentType: false,
        type: 'POST',
        // beforeSend: function() {
        //     $('.js-progress').addClass('animated');
        // },
        success:function(){
            grecaptcha.execute();
        },
        error: function(xhr, status, error) {
            // console.log(xhr.responseJSON);
            Object.keys(xhr.responseJSON).map(function(key) {
                $('#' + key).parents('.js-form-group').addClass('has-error');
            });
            that.find('button[type="submit"]').prop('disabled', false);
            $('.js-error-msg').fadeIn();
            $('#js-body').velocity("scroll", { duration: 500, easing: [0.645, 0.045, 0.355, 1.000] });
            // $('.js-progress').removeClass('animated');
        }
    });
}

function submitForm(token) {
    var that = $('#js-contact');
    $('.js-form-group').removeClass('has-error');
    that.find('button[type="submit"]').prop('disabled', 'disabled');
    var data = new FormData(that[0]);
    data.append('action', 'contact_form');

    $.ajax({
        url: ajaxurl,
        data: data,
        processData: false,
        contentType: false,
        type: 'POST',
        // beforeSend: function() {
        //     $('.js-progress').addClass('animated');
        // },
        success:function(data){
            // console.log(data);
            that.find('button[type="submit"]').prop('disabled', 'disabled');
            $('.js-error-msg').hide();
            $('.js-valid-msg').show();
            // $('.js-progress').removeClass('animated');
            that.css({
                'pointer-events': 'none',
                'filter': 'blur(1px)',
                'opacity': '0.2'
            });
            $window.scrollTop($('.js-anchor-form').offset().top - $('.js-header').outerHeight());
        },
        error: function(xhr, status, error) {
            // console.log(xhr.responseJSON);
            Object.keys(xhr.responseJSON).map(function(key) {
                $('#' + key).parents('.js-form-group').addClass('has-error');
            });
            that.find('button[type="submit"]').prop('disabled', false);
            $('.js-error-msg').fadeIn();
            // $('.js-progress').removeClass('animated');
        }
    });
}

$(function() {
    $('#js-contact #submit').on('click', function(event){
        event.preventDefault();
        validateFields('#js-contact', 'validate_fields_contact');
    });
});